import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import properties from '../../../modules/ajio-util/properties';
import { isMobile } from '../../utils/deviceTypeUtils';
import styles from './index.pcss';
import { FLEEK_STORE_NAME } from '../../../fleek/utils/constants';

export type Size = 'sm' | 'md' | 'lg';

interface RatingProps {
  onClickHandler: (rating: number) => void;
  rating: number;
  iconSize: Size;
  currentStore?: string;
}
const cx = classNames.bind(styles);
const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;
const Rating = (props: RatingProps): JSX.Element => {
  const { rating, onClickHandler, iconSize, currentStore = '' } = props;
  const [hoverState, setHoverState] = useState(0);
  const [displayToolTip, setDisplayToolTip] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  useEffect(() => {
    const deviceType = isMobile();
    setIsMobileScreen(deviceType);
  }, []);

  const clickHandler = (ratingValue: number) => {
    onClickHandler(ratingValue);
  };

  const getToolTipContent = () => {
    switch (hoverState) {
      case 1:
        return 'Very Bad';
      case 2:
        return 'Bad';
      case 3:
        return 'Good';
      case 4:
        return 'Very Good';
      case 5:
        return 'Excellent';
      default:
        return 'Good';
    }
  };

  return (
    <div className={cx('starContainer')} role="radiogroup" aria-labelledby="ratingLabel">
      {[1, 2, 3, 4, 5].map(ratingValue => (
        <button
          className={cx('star-icon-button', iconSize)}
          key={ratingValue}
          onMouseEnter={() => {
            setHoverState(ratingValue);
            setDisplayToolTip(true);
          }}
          onMouseLeave={() => {
            setHoverState(0);
            setDisplayToolTip(false);
          }}
          onClick={() => clickHandler(ratingValue)}
          role="radio"
          id="ratingBox"
          aria-checked={rating === ratingValue}
          aria-label={`${ratingValue} star${ratingValue > 1 ? 's' : ''}`}
        >
          {displayToolTip && !isMobileScreen && ratingValue === hoverState && (
            <div className={cx('tooltip-container')}>{getToolTipContent()}</div>
          )}
          {currentStore === FLEEK_STORE_NAME ? (
            <>
              <img
                className={cx('imageIcon')}
                src={
                  imageBaseRef +
                  `${
                    ratingValue <= rating || ratingValue <= hoverState
                      ? 'fleek_filled_star_rating.svg'
                      : 'fleek_unfilled_star_rating.svg'
                  }`
                }
                alt={
                  ratingValue <= rating || ratingValue <= hoverState
                    ? 'Star selected'
                    : 'Star unselected'
                }
              />{' '}
            </>
          ) : (
            <>
              <img
                className={cx('imageIcon')}
                src={
                  imageBaseRef +
                  `${
                    ratingValue <= rating || ratingValue <= hoverState
                      ? 'filled_star_rating.svg'
                      : 'unfilled_star_rating.svg'
                  }`
                }
                alt={
                  ratingValue <= rating || ratingValue <= hoverState
                    ? 'Star selected'
                    : 'Star unselected'
                }
              />
            </>
          )}
        </button>
      ))}
    </div>
  );
};

export default Rating;
